// @ts-ignore
 
import request from "src/lib/axios";

/** 获取角色列表 GET /api/v1/dashboard/role */
export async function DashboardRoleControllerListV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputRoleDtoArray>(
    "/api/v1/dashboard/role",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 创建角色 POST /api/v1/dashboard/role */
export async function DashboardRoleControllerCreateV1(
  body: MyApi.CreateRoleDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRoleDto>("/api/v1/dashboard/role", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取角色详情 GET /api/v1/dashboard/role/${param0} */
export async function DashboardRoleControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardRoleControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputRoleDto>(
    `/api/v1/dashboard/role/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新角色 PUT /api/v1/dashboard/role/${param0} */
export async function DashboardRoleControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardRoleControllerUpdateV1Params,
  body: MyApi.UpdateRoleDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputRoleDto>(
    `/api/v1/dashboard/role/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除角色（系统角色不可删除） DELETE /api/v1/dashboard/role/${param0} */
export async function DashboardRoleControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardRoleControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(`/api/v1/dashboard/role/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 设置角色权限（全量覆盖） PUT /api/v1/dashboard/role/${param0}/permissions */
export async function DashboardRoleControllerSetPermissionsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardRoleControllerSetPermissionsV1Params,
  body: MyApi.SetRolePermissionsDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputRoleDto>(
    `/api/v1/dashboard/role/${param0}/permissions`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取权限清单（只读） GET /api/v1/dashboard/role/permissions */
export async function DashboardRoleControllerPermissionsV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputPermissionDtoArray>(
    "/api/v1/dashboard/role/permissions",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}
